<template>
    <div class="navigation">
        <div
            class="navigation__preview"
            @click="togglePreview"
            v-if="activeTree && isTreeView"
        >
            <div class="navigation__link">
                Preview
            </div>
        </div>
        <div class="navigation__links">
            <router-link :to="{ name: 'Organisation' }">
                <div class="navigation__link">
                    <i class="el-icon-files"></i>
                    <span class="navigation__link__title">Dashboard</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'Links' }" v-if="isTreeView">
                <div class="navigation__link">
                    <i class="el-icon-notebook-2"></i>
                    <span class="navigation__link__title">
                        Links
                    </span>
                    <span v-if="updatedLinks > 0" class="badge">{{
                        updatedLinks
                    }}</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'Appearance' }" v-if="isTreeView">
                <div class="navigation__link">
                    <i class="el-icon-set-up"></i>
                    <span class="navigation__link__title">Appearance</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'Settings' }" v-if="isTreeView">
                <div class="navigation__link">
                    <i class="el-icon-setting"></i>
                    <span class="navigation__link__title">Settings</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'Reports' }" v-if="isTreeView">
                <div class="navigation__link">
                    <i class="el-icon-data-line"></i>
                    <span class="navigation__link__title">Reports</span>
                </div>
            </router-link>
            <a :href="previewLink" target="_blank" v-if="isTreeView">
                <div class="navigation__link">
                    <i class="el-icon-trophy"></i>
                    <span class="navigation__link__title">Live</span>
                </div>
            </a>
        </div>
        <div class="navigation__bottom">
            <router-link :to="{ name: 'Users' }">
                <div class="navigation__link">
                    <i class="el-icon-user"></i>
                    <span class="navigation__link__title">Users</span>
                </div>
            </router-link>
            <div class="navigation__profile">
                <div
                    class="navigation__profile__inner"
                    @click="toggleProfileFlyout"
                >
                    <div class="navigation__profile__avatar">
                        <i
                            class="el-icon-user-solid"
                            style="color:black;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);font-size:25px;"
                        ></i>
                    </div>
                    <div class="navigation__profile__title">
                        <span>{{ user.first_name }} {{ user.last_name }}</span>
                    </div>
                </div>
                <transition name="slide-in-left">
                    <div class="navigation__flyout" v-if="profileFlyoutVisible">
                        <router-link
                            class="navigation__flyout__item"
                            :class="{ active: tree.slug === activeTree.slug }"
                            v-for="tree in trees"
                            :key="tree.slug"
                            :to="{
                                name: 'Links',
                                params: { treeslug: tree.slug },
                            }"
                        >
                            <div class="navigation__flyout__item__avatar">
                                <img
                                    :src="tree.image.data.thumbnails.small"
                                    :alt="tree.name"
                                    v-if="tree.image"
                                />
                            </div>
                            <div class="navigation__flyout__item__title">
                                <span class="bold">{{ tree.name }}</span>
                                /{{ tree.slug }}
                            </div>
                        </router-link>
                    </div>
                </transition>
            </div>
            <div class="navigation__profile__logout grey" @click="logout">
                Logout
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as api from '@/api';

export default {
    components: {},
    data() {
        return {
            profileFlyoutVisible: false,
            isTreeView: this.$route.params.treeslug,
            updatedLinks: 0,
        };
    },
    watch: {
        '$route.params.treeslug': {
            handler(newVal) {
                this.isTreeView = newVal;
                this.profileFlyoutVisible = false;
                this.$store.dispatch('toggleDim', false);
                this.$store.dispatch('toggleLock', false);
            },
        },
        trees: {
            handler() {
                console.log('de trees changes');
                console.log(this.trees);
            },
        },
        activeTree: {
            deep: true,
            handler() {
                var helpval = 0;

                if (
                    this.activeTree !== false &&
                    typeof this.activeTree.links.data !== 'undefined' &&
                    this.activeTree.links.data.length > 0
                ) {
                    this.activeTree.links.data.forEach(t => {
                        if (Object.keys(t.updated_values).length > 0) helpval++;
                    });
                }

                this.updatedLinks = helpval;
            },
        },
    },
    computed: {
        ...mapGetters(['trees', 'activeTree', 'isMobileNav', 'user']),
        previewLink() {
            return '/' + this.activeTree.slug;
        },
    },
    mounted() {
        document.addEventListener('click', this.clickOutsideFlyout);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.clickOutsideFlyout);
    },
    methods: {
        togglePreview() {
            this.$emit('togglePreview');
        },
        clickOutsideFlyout($event) {
            if (
                $event.target.classList.contains('navigation__profile') ||
                $event.target.closest('.navigation__profile') ||
                !this.profileFlyoutVisible
            ) {
                return;
            }
            this.profileFlyoutVisible = false;
        },
        toggleProfileFlyout() {
            this.profileFlyoutVisible = !this.profileFlyoutVisible;
            if (this.isMobileNav) {
                this.$store.dispatch('toggleDim', this.profileFlyoutVisible);
                this.$store.dispatch('toggleLock', this.profileFlyoutVisible);
            }
        },
        logout() {
            api.auth.logout();
        },
    },
    beforeRouteLeave(to, from, next) {
        this.profileFlyoutVisible = false;
        this.$store.dispatch('toggleDim', false);
        this.$store.dispatch('toggleLock', false);
        next();
    },
};
</script>

<style lang="scss" scoped>
.navigation {
    $block: &;
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    height: $nav-height-mobile;
    background: $almost-black;
    color: white;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    z-index: 999;

    @include mq(tablet-landscape) {
        position: fixed;
        width: $nav-width-desktop;
        height: 100%;
        flex-direction: column;
        justify-content: space-between;
    }

    &__preview {
        margin-left: auto;

        @include mq(tablet-landscape) {
            display: none;
        }

        #{$block}__link {
            opacity: 1;
        }
    }

    &__links {
        display: flex;

        @include mq(tablet-landscape) {
            flex-direction: column;
        }
    }

    &__link {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 15px;
        font-size: 10px;
        text-transform: uppercase;
        height: 100%;
        color: white;
        opacity: 0.3;
        transition: all 300ms $ease-out-quad;
        position: relative;

        i {
            font-size: 24px;

            @include mq(tablet-landscape) {
                font-size: 28px;
            }
        }

        @include mq(tablet-landscape) {
            padding: 20px 0;
            opacity: 1;
            height: 100px;
        }

        .no-touch &:hover {
            background: $dark-grey;
        }

        .router-link-exact-active & {
            opacity: 1;

            @include mq(tablet-landscape) {
                background: white !important;
                color: $almost-black;
            }
        }

        svg {
            @include mq(tablet-landscape) {
                margin-bottom: 4px;
            }
        }

        &__title {
            display: block;
            margin-top: 8px;

            @include mq($until: tablet-landscape) {
                display: none;
            }
        }

        .badge {
            position: absolute;
            height: 20px;
            width: 20px;
            background: $red;
            border-radius: 50%;
            color: white;
            text-align: center;
            line-height: 20px;
            font-weight: 700;
            font-size: 11px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            margin-top: -22px;
            margin-left: 12px;
        }
    }

    &__profile {
        display: flex;
        align-items: center;
        padding: 0 10px;
        order: 0;
        cursor: pointer;

        &__inner {
            display: flex;
            align-items: center;
            flex-direction: column;

            @include mq(tablet-landscape) {
                width: 100%;
                padding: 20px 0 10px;
            }
        }

        &__avatar {
            position: relative;
            background: white;
            border-radius: 100%;
            width: 35px;
            height: 35px;
            margin-bottom: 4px;
            overflow: hidden;

            @include mq(tablet-landscape) {
                margin-right: 0;
                margin-bottom: 10px;
                height: 60px;
                width: 60px;
            }

            img {
                @include object-fit;
            }
        }

        &__title {
            font-weight: $font-weight-bold;
            line-height: 1;
            font-size: 10px;
            width: 100%;

            @include mq($until: tablet-landscape) {
                display: none;
            }

            @include mq(tablet-landscape) {
                text-align: center;
            }

            span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: block;
                width: 100%;
                box-sizing: border-box;

                &.slug {
                    padding-top: 4px;
                    display: block;
                    font-weight: $font-weight-regular;
                }
            }
        }

        &__logout {
            font-size: 11px;
            text-transform: uppercase;
            text-align: center;
            padding: 0 0 20px;
            transition: color 200ms $ease-out-quad;
            cursor: pointer;

            .no-touch &:hover {
                color: $red;
            }

            @include mq($until: tablet-landscape) {
                display: none;
            }
        }
    }

    &__flyout {
        position: fixed;
        top: $nav-height-mobile;
        right: 0;
        bottom: 0;
        width: 100%;
        background: $dark-grey;
        padding: 10px;
        overflow: auto;

        @include mq(tablet-landscape) {
            position: absolute;
            right: auto;
            top: auto;
            left: 100%;
            bottom: 20px;
            width: 400px;
            margin-left: 20px;
            overflow: hidden;

            &:before {
                content: '';
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 10px 10px 10px 0;
                border-color: transparent #{$dark-grey} transparent transparent;
                position: absolute;
                bottom: 40px;
                left: -10px;
            }
        }

        &__item {
            display: flex;
            align-items: center;
            color: white;
            padding: 15px 10px;
            font-size: 14px;

            &.router-link-active,
            &.active {
                background: white !important;
                color: $almost-black !important;
            }

            .no-touch &:hover {
                background: $medium-light-grey;
            }

            @include mq(tablet-landscape) {
                font-size: 12px;
            }

            &__avatar {
                position: relative;
                width: 60px;
                height: 60px;
                background: white;
                border-radius: 100%;
                margin-right: 18px;
                overflow: hidden;

                @include mq(tablet-landscape) {
                    width: 50px;
                    height: 50px;
                }

                img {
                    @include object-fit;
                }
            }

            &__title {
                display: flex;
                flex-direction: column;
            }
        }
    }

    &__bottom {
        margin-top: auto;

        @include mq($until: tablet-landscape) {
            margin: 0;
            display: flex;
            align-items: center;
            flex-direction: row-reverse;
        }
    }
}
</style>
